import { ChangeDetectionStrategy, Component, ElementRef, inject, Input, OnChanges, output, SimpleChanges, ViewChild } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { Router } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";
import { ApplicationService } from "../../services/application.service";

export interface MenuItem {
  href?: string;
  route: string;
  label: string;
  icon: string;
  index: number;
}

@Component({
  selector: "app-menu",
  templateUrl: "./menu.html",
  styleUrls: ["./menu.less"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIcon, TranslatePipe],
})
export class MenuComponent implements OnChanges {
  readonly applicationService = inject(ApplicationService);
  private readonly router = inject(Router);

  public requestclose = output();

  @Input("items")
  public items: MenuItem[] = [];
  @ViewChild("ulContainer", { static: false }) ulContainer: ElementRef<HTMLUListElement> | null = null;
  @ViewChild("closeButton") closeButton: ElementRef<HTMLAnchorElement> | null = null;
  @ViewChild("menuButton") menuButton: ElementRef<HTMLAnchorElement> | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.items) {
      this.ulContainer && this.ulContainer.nativeElement.getElementsByTagName("a")[0]?.focus();
    }
    this.closeButton && this.closeButton.nativeElement.addEventListener("keydown", (e) => this.focusHandler(e));
  }

  /**
   * Hides the menu
   */
  public hide(e?: KeyboardEvent) {
    if (e && !this.checkKeyEscapeEnter(e)) return;
    this.requestclose.emit();
    this.menuButton && this.menuButton.nativeElement.focus();
  }
  checkKeyEnter(e: KeyboardEvent) {
    if (e.key === "Enter") return true;
    return false;
  }
  checkKeyEscapeEnter(e: KeyboardEvent) {
    if (e.key === "Enter") return true;
    if (e.key === "Escape") return true;
    return false;
  }

  /**
   * Navigates to a link.
   */
  public navigate(link: string, e?: KeyboardEvent) {
    if (e && !this.checkKeyEnter(e)) return;
    if (link) {
      if (link.includes("http")) {
        window.open(link, "_blank");
      } else {
        this.router.navigate([link]).then(() => {
          this.requestclose.emit();
        });
      }
    }
  }

  public focusHandler(e: KeyboardEvent) {
    const currentTabIndex = Number((e.target as HTMLAnchorElement).getAttribute("tabindex"));
    if (e.key === "Escape") {
      this.hide(e);
      return;
    }
    if (!this.closeButton) return;
    if (e.key === "Tab" && currentTabIndex === this.items.length + 1) {
      this.closeButton.nativeElement.focus();
    }
    if (!this.closeButton) return;
    if (e.shiftKey && e.key === "Tab" && currentTabIndex === 1) {
      this.closeButton.nativeElement.focus();
      setTimeout(() => {
        this.closeButton && this.closeButton.nativeElement.focus();
      }, 0);
    } else if (!e.shiftKey && e.key === "Tab" && currentTabIndex > this.items.length) {
      setTimeout(() => {
        this.ulContainer && this.ulContainer.nativeElement.getElementsByTagName("a")[0].focus();
      }, 0);
    }
  }
}
